export const LIST_FEATURES = [
  { bold: 'Send photos.', plain: ' By email or mobile app anytime from anywhere.' },
  { bold: 'Videos and Captions.', plain: ' Videos and captions bring your memories to life.' },
  { bold: 'Remote settings.', plain: ' Change your Frame’s settings from the app.' },
  { bold: 'Albums.', plain: ' Create, edit, and view photo albums.' },
  { bold: 'Slideshow mirroring.', plain: ' View your photos on any screen.' },
]

export const CALENDAR_LIST_FEATURES = [
  { plain: 'Email photos to your Calendar or upload them in the Skylight app.' },
  { plain: 'Watch them appear on your photo slideshow instantly.' },
  { plain: 'Simply tap on the screensaver to view your schedule.' },
]
